/* eslint-disable no-unused-vars */
/* eslint-disable no-debugger */
import { mapColors } from "@/common/constants";
import { date } from "@/components/mixins/date";
import { DateHelper } from "@/utility/dateHelper.js";
import Vue from "vue";

export const configAxisType = {
  0: {
    unit: "mm",
    name: "POSF",
    color: "#0066cc"
  },
  1: {
    unit: "mm",
    name: "ERR",
    color: "#cc66ff"
  },
  2: {
    unit: "rpm",
    name: "VCMD",
    color: "#33cc33"
  },
  3: {
    unit: "%",
    name: "TCMD",
    color: "#ff3300"
  },
  4: {
    unit: "rpm",
    name: "SPEED",
    color: "#00ffcc"
  }
};

export const cycleInfoByName = name => {
  return Object.values(configAxisType).find(item => item.name === name) || {};
};

export const roundValue = (value, places = 2) => {
  return +(Math.round(value + "e+" + places) + "e-" + places);
};

export const checkJsonString = str => {
  try {
    const res = JSON.parse(str);
    //console.log("checkJsonString CYCLE RESULT:", res);
    return res;
  } catch (e) {
    return false;
  }
};

const BARRED_COLOR = {
  pattern: {
    path: {
      d: "M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11"
    },
    width: 10,
    height: 10,
    opacity: 1,
    color: mapColors.green,
    backgroundColor: "#ddd"
  }
};

export const cycleResultStatusColor = {
  OK: mapColors.green,
  WARNING: mapColors.yellow,
  LOWER_WARNING: mapColors.yellow, //"#fedf6b",
  UPPER_WARNING: mapColors.yellow, //"#fecb09",
  LOWER_ERROR: mapColors.red, //"#fd8389",
  UPPER_ERROR: mapColors.red, //"#f10412",
  ERROR: mapColors.red,
  FINGERPRINT: BARRED_COLOR,
  ABORTED: "#fff",
  undefined: "#fff"
};

export const SCORE_COLOR = "#026cff";

export const mapResultStatusColor = status =>
  cycleResultStatusColor[status ? status.toUpperCase() : null] || mapColors.undefined; //undefined=white

export const mapDataToCyclesData = async data => {
  let items = data;

  if (!items) {
    items = [];
  }

  // const numberOfPoints = items.length;
  // const start = new Date();

  const result = await dataToSeries(items);

  // console.info(
  //   `[Info] Number of points: ${numberOfPoints}. Execution time: ${new Date() - start}ms.`
  // );

  return result;
};

const dataToSeries = async elements => {
  const categories = [];

  const isAborted = cycle => {
    return cycle.messages && cycle.messages.length > 0;
  };

  let series = [
    // "STAUSES" data,
    {
      data: elements.map(cycle => {
        const category =
          DateHelper.formatTimeWithSeconds(cycle.startTime, Vue.i18n.locale()) +
          " " +
          date.methods.formatDateMonthAndDay(cycle.startTime, Vue.i18n.locale());
        categories.push(category);

        const name = isAborted(cycle)
          ? "ABORTED"
          : cycle.status || (cycle.isFingerprint ? "FINGERPRINT" : "-");

        const color = cycleResultStatusColor[name] || "#F0F0F0";

        const custom = {
          extraInformation: getCustomText(cycle, name)
        };
        const y = 100; //cycle.score || 0;

        return {
          name,
          y,
          color,
          custom
        };
      })
    },
    // "SCORE" data
    {
      data: elements.map(cycle => {
        if (!cycle.isFingerprint || !cycle.score) {
          const custom = {
            extraInformation: cycle.score
              ? `<b style='color:${SCORE_COLOR};font-size:1.5rem'>${cycle.score}%<b>`
              : null
          };
          const y = cycle.score;

          return { y, custom, color: SCORE_COLOR };
        } else {
          return {
            y: null
          };
        }
      })
    }
  ];

  series = {
    series,
    categories
  };

  return {
    normalizedPoints: elements,
    series
  };
};

const getCustomText = (cycle, name) => {
  let text = false;

  if (cycle) {
    const { startTime, endTime, isFingerprint, score } = cycle;
    const from = (startTime && new Date(startTime).getTime()) || undefined;
    const to = new Date(endTime).getTime();
    const amount = (to - from) / 1000;

    const startText =
      DateHelper.formatTimeWithSeconds(from, Vue.i18n.locale()) +
      " " +
      date.methods.formatDateMonthAndDay(from, Vue.i18n.locale());
    const endText =
      DateHelper.formatTimeWithSeconds(to, Vue.i18n.locale()) +
      " " +
      date.methods.formatDateMonthAndDay(to, Vue.i18n.locale());
    const amountText = DateHelper.getFancyTimeFormat(amount);

    const info = name;
    const scoreText = score
      ? `<br/><b style='color:${SCORE_COLOR};font-size:1.5rem'>${score}%</b>`
      : "";

    const tool =
      cycle.type === "TOOLS_CHECK" && cycle.tool
        ? `<b>TOOL</b>: ${cycle.tool.toolId} / ${cycle.tool.family}<br/>`
        : "";

    text =
      tool +
      `<b style='color:${SCORE_COLOR};font-size:2rem'>${info}</b>${scoreText}<br/>${startText}<br/>${endText}<br/>${amountText}`;
  }

  return text;
};
